export class Debounce {
    private intervalMs: number
    private timeout: NodeJS.Timeout | null = null

    public constructor(ms: number) {
        this.intervalMs = ms
    }

    public execute = (func: () => void) => {
        if (this.timeout) clearTimeout(this.timeout)

        this.timeout = setTimeout(func, this.intervalMs)
    }
}
